import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Label } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { BTN, EVENT_TYPES } from "./hrUtils";

const EMPTY = { type: "entretien_annuel", date: "", title: "", description: "" };

export const HrEvents = ({ empId, onChanged }) => {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState(EMPTY);
  const load = useCallback(() => api.get(`/hr/employees/${empId}/events`).then((r) => setRows(r.data)).catch(() => {}), [empId]);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!f.date || !f.title) { toast.error("Date et intitulé obligatoires"); return; }
    try { await api.post(`/hr/employees/${empId}/events`, f); toast.success("Événement ajouté"); setF(EMPTY); load(); onChanged && onChanged(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => {
    if (!window.confirm("Supprimer cet événement ?")) return;
    try { await api.delete(`/hr/events/${id}`); load(); onChanged && onChanged(); } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div className="mt-3 space-y-3" data-testid="rh-events">
      <div className="space-y-2 rounded-2xl bg-gray-50 p-3">
        <Label>Nouvel événement RH</Label>
        <div className="grid grid-cols-2 gap-2">
          <Select value={f.type} onValueChange={(v) => setF({ ...f, type: v })}>
            <SelectTrigger data-testid="rh-event-type" className="rounded-xl"><SelectValue /></SelectTrigger>
            <SelectContent>{Object.entries(EVENT_TYPES).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
          </Select>
          <Input data-testid="rh-event-date" type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className="rounded-xl" />
        </div>
        <Input data-testid="rh-event-title" placeholder="Intitulé" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className="rounded-xl" />
        <Input placeholder="Description (factuelle)" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} className="rounded-xl" />
        <Button data-testid="rh-event-add" onClick={add} className={`w-full ${BTN}`}><Plus className="mr-1 h-4 w-4" />Ajouter</Button>
      </div>
      {rows.length === 0 ? <p className="text-sm text-gray-400">Aucun événement.</p> : (
        <ol className="relative space-y-3 border-l-2 border-emerald-100 pl-4">
          {rows.map((r) => (
            <li key={r.id} className="relative" data-testid={`rh-event-${r.id}`}>
              <span className="absolute -left-[23px] top-1.5 h-3 w-3 rounded-full bg-[#065F46]" />
              <div className="flex items-start gap-2">
                <div className="min-w-0 flex-1">
                  <p className="text-xs text-gray-400">{fmtDate(r.date)} · {EVENT_TYPES[r.type] || r.type}</p>
                  <p className="text-sm font-semibold">{r.title}</p>
                  {r.description && <p className="text-xs text-gray-500">{r.description}</p>}
                </div>
                <button onClick={() => del(r.id)} className="rounded-lg p-1 text-rose-500 hover:bg-rose-50"><Trash2 className="h-3.5 w-3.5" /></button>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
